
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/payment/history",
      function () {
        return require("private-next-pages/payment/history/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/payment/history"])
      });
    }
  